module.exports = __webpack_public_path__ + "static/heavy_royal2-4852bc88337b70af721a6f367945744b.jpg";